import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { RootState } from '../state/store';
import { ElementUI } from '../types/interfaces';

function generateVisibilityClasses(
  elementUIs: ElementUI[]
): Record<string, boolean> {
  // Check if `wholeui__roles` is set to true
  const showAllUI = elementUIs.some(
    (item) => item.code === 'wholeui__roles' && item.visible
  );
  if (showAllUI) return { wholeui__roles: true }; // Return empty object to indicate all items should be shown

  // Otherwise, build visibility classes based on the elementUIs
  const visibilityClasses: Record<string, boolean> = {};
  elementUIs.forEach((item) => {
    visibilityClasses[item.code] = item.visible;
  });

  return visibilityClasses;
}

export function useVisibilityClasses() {
  const elementUIs = useSelector((state: RootState) => state.auth.elementUIs);

  // Memoize visibilityClasses to avoid recalculation on every render
  const visibilityClasses = useMemo(() => {
    // Return empty object if `wholeui__roles` is true, otherwise generate visibility classes
    return elementUIs.length > 0 ? generateVisibilityClasses(elementUIs) : {};
  }, [elementUIs]);

  return visibilityClasses;
}
